import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 引入全局样式文件
import '@/assets/styles/global.css'

// 创建Vue 3应用实例
const app = createApp(App)

// 全局配置axios
app.config.globalProperties.$axios = axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

// 注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用路由和ElementPlus
app.use(router)
app.use(ElementPlus)

// 挂载应用
app.mount('#app')
